import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { CheckboxContainer, Input, Label } from '../styles';
import { FauxInput } from '../shared';

var Checkbox = function Checkbox(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'middle' : _ref$align,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      children = _ref.children,
      className = _ref.className,
      dataTest = _ref['data-test'],
      inputId = _ref.inputId,
      inputProps = _objectWithoutProperties(_ref, ["align", "size", "children", "className", "data-test", "inputId"]);

  return /*#__PURE__*/React.createElement(CheckboxContainer, {
    align: align,
    className: className,
    "data-test": dataTest,
    size: size
  }, /*#__PURE__*/React.createElement(Input, _extends({
    id: inputId,
    inputSize: size,
    type: "checkbox"
  }, inputProps)), /*#__PURE__*/React.createElement(FauxInput, {
    size: size
  }), /*#__PURE__*/React.createElement(Label, {
    htmlFor: inputId
  }, children));
};

Checkbox.displayName = 'Checkbox';
export default Checkbox;